<template>
  
  <div class="mr-3">
  <div v-if="!$store.state.isOffline">
    
    <!-- <v-app-bar-nav-icon v-else  @click="openDrawer"></v-app-bar-nav-icon>  -->
    <v-btn @click="openDrawer" icon><v-icon>$menu</v-icon></v-btn>
    <v-btn @click="goBack" v-if="$store.state.previous != null" icon color="white"><v-icon>fa-arrow-left</v-icon></v-btn>
  </div>
  <div v-else-if="$store.state.previous.name != 'BuildingComponentDetails'">
    <v-btn v-if="$store.state.previous != null" @click="goBack" icon color="white"><v-icon>fa-arrow-left</v-icon></v-btn>
  </div>
  <!-- <a style=""
    class="subtitle-1"
    @click="goBack"
  >
    <v-icon>arrow_back</v-icon>
    {{ $store.state.previous ? $store.state.previous.breadcrumb: ""}}
  </a> -->
  </div>
</template>


<script>
export default {
  name: "BackButton",
  data() {
    return {};
  },
  computed:{
    bb(){
      return this.$store.state.previous
    }
  },
  methods: {
    goBack() {
      if (this.$store.state.previous) {
        if(this.$store.state.previous.params){
           this.$router.push({
          name: this.$store.state.previous.name,
          params: this.$store.state.previous.params
        });
        }else{
          this.$router.push({
          name: this.$store.state.previous.name,
          params: { id: this.$store.state.previous.id }
        });
        }
        
      } else {
        this.$router.push({
          name: "Projects"
        });
      }
    },
    openDrawer(){
      this.$emit('openDrawer');
    }
  },
  watch:{
    bb(n,o){
    },
  },
  created() {
   
  }
};
</script>


// WEBPACK FOOTER //
// src/components/BackButton.vue